import { render, staticRenderFns } from "./aipost.vue?vue&type=template&id=39cc730e&"
import script from "./aipost.vue?vue&type=script&lang=js&"
export * from "./aipost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports